import React from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { mapState } from '../map';
import { deleteAllSelected, deleteSelected } from '../redux/slice/interactSlice'
import Feature, { FeatureLike } from "ol/Feature";
import { BgisMapDetailBody } from '../../bgis/components/maparea/sidebar/details';
import { zoomTo } from '../redux/slice/mapSlice';
import RenderFeature from 'ol/render/Feature';
import { createEmpty, extend } from 'ol/extent';


export const MapDetailBody = () => {


        const selectedGstkCount = useAppSelector(state => state.interact.selectedCount);

        const dispatch = useAppDispatch();

        const deleteAll = () => {
                dispatch(deleteAllSelected());
        }

        const deleteSingleSelected = (key: string) => {
                dispatch(deleteSelected(key));
        }

        const zoomToSelectedFeature = (feature: FeatureLike) => {
                if (feature instanceof Feature) {
                        dispatch(zoomTo(feature.getGeometry()));
                } else if (feature instanceof RenderFeature) {
                        dispatch(zoomTo(feature.getExtent()));
                }
        }

        const zoomToAllSelectedFeatures = () => {
                let extent = createEmpty();
                [...mapState.selectedFeatures.values()].forEach(selGst => {
                        const extendWith = selGst.getGeometry()?.getExtent();
                        if (extendWith) {
                                extent = extend(extent, extendWith);
                        }
                });
                dispatch(zoomTo(extent));
        }




        return <>
                <BgisMapDetailBody>
                        <table  >
                                <thead  >
                                        <tr >
                                                <th colSpan={5}>aktuell sind {selectedGstkCount} Grundstücke ausgewählt<br /></th>
                                        </tr>
                                </thead>
                                <tbody >
                                        <tr className='bgis-border-bottom bgis-hover'>
                                                <td title="Katastralgemeindenummer">Kg. Nr.</td>
                                                <td title="Grundstücksnummer">Gstk. Nr.</td>
                                                <td title="Einlagezahl">Ez.</td>
                                                <td>
                                                        <button onClick={zoomToAllSelectedFeatures}>
                                                                <i className='bgis-icon-zoom-in' title='Zoomt auf alle ausgewählten Grundstücke'></i>
                                                        </button>
                                                </td>
                                                <td>
                                                        <button onClick={deleteAll} title='Löscht alle ausgewählten Grundstück'>
                                                                <i className='bgis-icon-delete'></i>
                                                        </button>
                                                </td>
                                        </tr>
                                        {[...mapState.selectedFeatures.values()].map(
                                                gstFeature => (<tr className='bgis-border-bottom bgis-hover'  >
                                                        <td  >{gstFeature.get('kg')}</td>
                                                        <td  >{gstFeature.get('gnr')}</td>
                                                        <td  >{gstFeature.get('ez')}</td>
                                                        <td><button onClick={() => {
                                                                return zoomToSelectedFeature(gstFeature);
                                                        }} title='Zoomt auf das ausgewählte Grundstück'><i className='bgis-icon-zoom-in' /></button>
                                                        </td><td>
                                                                <button onClick={() => {
                                                                        deleteSingleSelected(`${gstFeature.get('kg')}_${gstFeature.get('gnr')}`);
                                                                        return false;
                                                                }} title='Löscht das ausgewählte Grundstück'><i className='bgis-icon-delete'></i></button></td>
                                                </tr>))}</tbody>
                        </table>
                </BgisMapDetailBody>
        </>


}